import styles from "../../../styles/Home.module.css";
import { Text, Input, Button, Box } from "@chakra-ui/react";
import React, { useState, useCallback } from "react";
import BaseLayout from "../../../components/en/index_layout";

import { sendEmail } from "../../../provider/auth";

export default function AuthReqPassword() {
  const [email, setEmail] = useState("");

  // input 상태 함수
  const _handleChange = useCallback((e) => {
    const { name, value } = e.target;
    switch (name) {
      case "email":
        setEmail(value);
        break;
    }
  });

  // 이메일 보내는 실행 함수
  const _handleSubmit = async () => {
    if (email !== "") {
      sendEmail(email);
    } else {
      alert("Please enter your email.");
    }
    return;
  };

  return (
    <BaseLayout>
      <Box className="base_container">
        <Box className="req-password__base">
          <Text className="req-password__title">Reset Password</Text>
          <p
            style={{
              marginBottom: "40px",
            }}
          >
            Enter the email address that you would like to reset the password.
          </p>
          <Box className="req-password__box flex-column-center">
            <Text width="300px">Email Address</Text>
            <Input
              className="req-password__input"
              name="email"
              placeholder="example@mail.com"
              onChange={_handleChange}
            />
            <Button className="req-password__btn" onClick={_handleSubmit}>
              Send Instruction
            </Button>
          </Box>
        </Box>
      </Box>
    </BaseLayout>
  );
}
